import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  orderDish,
  removeAllOrders,
  confirmOrder,
  fetchShopInfo,
  fetchDishMarketInfos,
  fetchOrderDiscountInfo,
  fetchMenuData,
} from '../../action/dish-menu/dish-menu';
import { fetchBrandInfo, setErrorMsg } from '../../action/common-action/common-action';
import * as actions from '../../action/goods-detail';
import DishDescPopup from '../../component/dish-menu/detail/dish-desc-popup';
import CartContainer from '../../component/dish-menu/cart/cart-container';
import DishDetailContainer from '../../component/dish-menu/detail/dish-detail-container';
import { getUrlParam, getRecommendDish } from '../../helper/common-helper';
import { getOrderedDishes } from '../../helper/dish-helper';
import Toast from '../../component/mui/toast.jsx';
import { initWXShareEventWithConfig } from '../../helper/wx-share-config.js';
import { WxSharEventEntry } from '../../helper/const.js';
import { setIndustryToBody } from '../../helper/industry-helper.js';
import buryingPoint from '../../helper/divolte/register-divolte';

const type = getUrlParam('type');

/**
 * 商品详情页
 */
class GoodsDetailApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      propsPopupExpand: false,
    };

    this.clearErrorMsg = this.clearErrorMsg.bind(this);
    this.getRecommendDish = this.getRecommendDish.bind(this);
  }

  getChildContext() {
    const { brandInfo = {} } = this.props;

    return { brandType: brandInfo.brandType };
  }

  componentWillMount() {}

  componentDidMount() {
    const { fetchIndustryInfo, fetchGoodsDetail, initOrderedDishes, setGoodsDetailWithRecommendList } = this.props;

    initOrderedDishes();
    this.props
      .fetchShopInfo()
      .then(fetchIndustryInfo)
      .then(industry => {
        setIndustryToBody(industry);
      })
      .then(() => fetchGoodsDetail(getUrlParam('dishId')))
      .then(this.props.fetchDishMarketInfos)
      .then(this.props.fetchOrderDiscountInfo)
      .then(this.getRecommendDish)
      .then(recommendDishList => setGoodsDetailWithRecommendList(recommendDishList, this.props.dishesDataDuplicate))
      .then(() => {
        // 设置标题title
        document.title = (this.props.goodsDetail && this.props.goodsDetail.name) || '商品详情';
        initWXShareEventWithConfig({ entry: WxSharEventEntry.DETAIL, _this: this });
      });

    this.props.fetchBrandInfo();
    this.buryingPointBrowsePage();
    initWXShareEventWithConfig({ entry: WxSharEventEntry.DETAIL, _this: this });
  }

  componentDidUpdate() {
    // initWXShareEventWithConfig({ entry: WxSharEventEntry.DETAIL, _this: this });
  }

  buryingPointBrowsePage() {
    const dishId = getUrlParam('dishId') || '';
    buryingPoint.send('ViewCommodityDetail', { pageType: '详情页', commodityId: dishId });
  }

  handlePopupClick() {
    this.setState({ propsPopupExpand: true });
  }

  togglePropsPopupVisible = () => {
    const { propsPopupExpand } = this.state;

    this.setState({ propsPopupExpand: !propsPopupExpand });
  };

  handleDishDetailAddBtnTap = (dishData, increment, option) => {
    this.togglePropsPopupVisible();
    this.props.orderDish(dishData, increment, option);
  };

  handleCloseDishDesc = () => {
    this.props.gotoGoodsListPage();
  };

  renderShoppingCart() {
    const {
      shopInfo = { openStatus: false },
      openTimeList = [],
      isAcceptTakeaway = false,
      isAcceptOrder,
      dishesDataDuplicate,
      wmCartImageUrl,
      tsCartImageUrl,
    } = this.props;

    const takeawayServiceProps = {};
    const orderedDishes = getOrderedDishes(dishesDataDuplicate);

    return (
      <div className="o-flex__fixed">
        <CartContainer
          tinyRemainEnable={false}
          shopInfo={shopInfo}
          dishes={orderedDishes}
          takeawayServiceProps={takeawayServiceProps}
          openTimeList={openTimeList}
          isAcceptTakeaway={isAcceptTakeaway}
          onOrderBtnTap={this.props.orderDish}
          onBillBtnTap={this.props.confirmOrder}
          onClearBtnTap={this.props.removeAllOrders}
          toggleDishDescPopup={() => {}}
          urlType={type}
          isAcceptOrder={isAcceptOrder}
          wmCartImageUrl={wmCartImageUrl}
          tsCartImageUrl={tsCartImageUrl}
          isDisableTinyRemain
        />
      </div>
    );
  }

  getRecommendDish(callback) {
    return getRecommendDish((type || '').toLowerCase(), 'dish_detail_page')
      .then(recommendDishList => {
        this.setState({ recommendDishList });
        return recommendDishList;
      })
      .catch(errMsg => {
        this.props.setErrorMsg({ text: errMsg });
      });
  }

  renderDescript() {
    const { goodsDetail, dishesDataDuplicate, dishTypesData, menuDataStatus, dishPageTpl } = this.props;
    const { recommendDishList } = this.state;
    if (!goodsDetail) {
      return;
    }

    const goodsDetailWithMarketInfo = dishesDataDuplicate.filter(item => item.id === goodsDetail.id)[0];

    return (
      <div className="o-flex__fluid">
        <DishDescPopup
          dish={goodsDetailWithMarketInfo}
          backWhenPropsBtnTap={false}
          mode={DishDescPopup.Modes.PAGE}
          dishesDataDuplicate={dishesDataDuplicate}
          dishTypesData={dishTypesData}
          menuDataStatus={menuDataStatus}
          onOrderBtnTap={this.props.orderDish}
          onCloseBtnTap={this.handleCloseDishDesc}
          onPropsBtnTap={this.togglePropsPopupVisible}
          recommendDishList={recommendDishList}
          getRecommendDish={this.getRecommendDish}
          urlType={type}
          theme={dishPageTpl}
        />
      </div>
    );
  }

  renderPropsPopup() {
    const { propsPopupExpand } = this.state;
    const { goodsDetail, dishesDataDuplicate } = this.props;

    if (!propsPopupExpand || !goodsDetail) {
      return;
    }

    const { sameDishIndexs = [] } = goodsDetail;
    const sameRuleDishList = sameDishIndexs.map(dishIndex => dishesDataDuplicate[dishIndex]);

    return (
      <div>
        <DishDetailContainer
          dish={goodsDetail}
          sameRuleDishList={sameRuleDishList}
          onAddToCarBtnTap={this.handleDishDetailAddBtnTap}
          onCloseBtnTap={this.togglePropsPopupVisible}
        />
      </div>
    );
  }

  clearErrorMsg() {
    this.props.setErrorMsg(null);
  }

  render() {
    const { shopInfo = {}, errorMessage } = this.props;

    return (
      <div className="o-flex o-flex--column">
        {this.renderDescript()}
        {this.renderPropsPopup()}
        {this.renderShoppingCart()}

        <div id="handleInputDOM" data-editable={shopInfo.goodsNumEditable} style={{ display: 'none' }} />
        {errorMessage.text && <Toast errorMessage={errorMessage.text} clearErrorMsg={this.clearErrorMsg} timeout={errorMessage.timeout} />}
      </div>
    );
  }
}

GoodsDetailApplication.propTypes = {
  goodsDetail: React.PropTypes.object,
  shopInfo: React.PropTypes.object,
  errorMessage: React.PropTypes.object,

  fetchGoodsDetail: React.PropTypes.func.isRequired,
  initOrderedDishes: React.PropTypes.func.isRequired,
  orderDish: React.PropTypes.func.isRequired,
  confirmOrder: React.PropTypes.func.isRequired,
  gotoGoodsListPage: React.PropTypes.func.isRequired,
  setGoodsDetailWithRecommendList: React.PropTypes.func.isRequired,
};

GoodsDetailApplication.childContextTypes = {
  brandType: React.PropTypes.string,
};

GoodsDetailApplication.topNavSelf = true;

const mapActionsToProps = dispatch => {
  const mergedActions = Object.assign(
    {
      orderDish,
      removeAllOrders,
      confirmOrder,
      fetchShopInfo,
      fetchDishMarketInfos,
      fetchOrderDiscountInfo,
      fetchBrandInfo,
      fetchMenuData,
      setErrorMsg,
    },
    actions,
  );

  return bindActionCreators(mergedActions, dispatch);
};

export default connect(state => state, mapActionsToProps)(GoodsDetailApplication);



// WEBPACK FOOTER //
// ./src/container/goods-detail/application.jsx